import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.isSupported().then((supported) => {
      if (!supported) {
        this.hideElement();
      }
    });
  }

  async isSupported() {
    if (!window.PublicKeyCredential) return false;

    try {
      const isAvailable = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
      if (!isAvailable) return false;
    } catch (error) {
      console.error("Error checking for passkey support:", error);
      return false;
    }

    return true;
  }

  hideElement() {
    this.element.style.display = "none";
  }
}
